import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import image2 from "../assets/Gemini_Generated_Image_sh8x5nsh8x5nsh8x (2).png";

/**
 * Viz App Section Card
 * 
 * Content card for grid layout (no image, image is in right column)
 */
const VizAppSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const features = [
    "Instant audio explanations for quick understanding",
    "Interactive body summary with health labels",
    "Real-time trend analysis and risk calculations",
    "Personalized wellness tips and recommendations",
  ];

  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "24px",
          sm: "32px",
          md: "40px",
        },
        backgroundColor: "transparent",
        borderRadius: "16px",
        height: "100%",
        display: "flex",
        flexDirection: { xs: "column", md: "row-reverse" },
        gap: { xs: "24px", md: "32px" },
        alignItems: "center",
        transition: "all 0.3s ease",
      }}
    >
      {/* Right side - Image */}
      <Box
        sx={{
          flex: { xs: "none", md: "0 0 40%" },
          width: { xs: "100%", md: "auto" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={image2}
          alt="Viz App"
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "523px" },
            height: { xs: "330px", md: "396px" },
            objectFit: "cover",
            borderRadius: "16px",
            border: "4px solid rgba(53, 103, 214, 0.25)",
            boxShadow: "0 4px 16px rgba(53, 103, 214, 0.15)",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 8px 24px rgba(53, 103, 214, 0.25)",
              borderColor: "rgba(53, 103, 214, 0.4)",
            },
          }}
        />
      </Box>

      {/* Left side - Content */}
      <Box
        sx={{
          flex: { xs: "none", md: "1" },
          width: { xs: "100%", md: "auto" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "24px", sm: "32px", md: "36px" },
            fontWeight: 700,
            fontFamily: "'Poppins', sans-serif",
            color: "#3567D6",
            marginBottom: { xs: "16px", md: "20px" },
          }}
        >
          Viz App
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            color: "#64748b",
            lineHeight: 1.7,
            marginBottom: { xs: "24px", md: "32px" },
          }}
        >
          Web-based Smart Report application with world class UI/UX and features, Instant, secure and mobile friendly, it's a product for the 21st century.
        </Typography>

        {/* Features List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "14px", md: "18px" },
          }}
        >
          {features.map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <CheckCircleIcon
                sx={{
                  color: "#3567D6",
                  fontSize: { xs: "20px", md: "22px" },
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "14px", md: "15px" },
                  color: "#1e293b",
                  lineHeight: 1.6,
                  fontWeight: 500,
                }}
              >
                {feature}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default VizAppSection;

